import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M11.43 14.74H4.58a3.32 3.32 0 0 1-3.32-3.32V4.57a3.32 3.32 0 0 1 3.32-3.32h6.85a3.32 3.32 0 0 1 3.32 3.32v6.85a3.32 3.32 0 0 1-3.32 3.32Zm-6.85-12a1.81 1.81 0 0 0-1.82 1.83v6.85a1.81 1.81 0 0 0 1.82 1.82h6.85a1.81 1.81 0 0 0 1.82-1.82V4.57a1.81 1.81 0 0 0-1.82-1.82Zm3.1 8.34L12.82 6a.77.77 0 0 0 0-1.07.75.75 0 0 0-1.06 0L7.15 9.5l-2-2a.75.75 0 1 0-1.1 1.03l2.57 2.56a.73.73 0 0 0 .53.22.74.74 0 0 0 .53-.22Z';
const draw24px =
  'M16.57,20.75H7.43a4.18,4.18,0,0,1-4.18-4.18V7.43A4.18,4.18,0,0,1,7.43,3.25h9.14a4.19,4.19,0,0,1,4.18,4.18v9.14A4.18,4.18,0,0,1,16.57,20.75Zm-9.14-16A2.68,2.68,0,0,0,4.75,7.43v9.14a2.68,2.68,0,0,0,2.68,2.68h9.14a2.68,2.68,0,0,0,2.68-2.68V7.43a2.68,2.68,0,0,0-2.68-2.68Zm4,11.21L18.24,9.1a.74.74,0,0,0,0-1.06.75.75,0,0,0-1.06,0l-6.32,6.33L8,11.47A.75.75,0,1,0,6.9,12.53L10.33,16a.75.75,0,0,0,.53.22A.79.79,0,0,0,11.39,16Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const CheckboxCheckedIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'checkboxChecked')) as IconWithRender;

CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
CheckboxCheckedIcon.propTypes = Icon.propTypes;
CheckboxCheckedIcon.renderIcon = (props) => <CheckboxCheckedIcon {...props} />;
export default CheckboxCheckedIcon;
